@for (item of items.options; track item; let i = $index) {
  <div
    [id]="items.id + i"
    [ngClass]="['form-check','ds-eod-radio','ds-eod-radio--' + items.size]">
    
    <input
      [attr.type]="items.type || 'radio'"
      [id]="'ds-radio-input-' + i"
      [class]="'form-check-input is-' + (items.color || 'primary')"
      [checked]="item.checked"
      (input)="onClick($event, i)"
      [attr.name]="item.name || 'ds-radio-' + i"
      (change)="onClick($event, i)"
      [attr.value]="item.value"
    />
    <label class="form-check-label" [attr.for]="'ds-radio-input-' + i">
      {{ item.label }}
      @if(item.anchorText){<a [href]="item.link" class="secondary-text">{{ item.anchorText }}</a>}
      @if(item.secondaryText){<span class="secondary-text">{{ item.secondaryText }}</span>}
    </label>
  </div>
}